/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyPostBody
 */
export interface SurveyPostBody {
    /**
     * Examples, "onboarding", "reassessment"
     * @type {string}
     * @memberof SurveyPostBody
     */
    surveyType?: string;
    /**
     * Completion timestamp, in ISO-8601 format. E.g. 2019-11-15T12:15:00+02
     * @type {string}
     * @memberof SurveyPostBody
     */
    completedAt?: string;
    /**
     * Completion speed, in seconds per survey. [0-Infinity)
     * @type {number}
     * @memberof SurveyPostBody
     */
    completionSpeed?: number;
    /**
     * 
     * @type {Array<object>}
     * @memberof SurveyPostBody
     */
    completedSections?: Array<object>;
}

export function SurveyPostBodyFromJSON(json: any): SurveyPostBody {
    return SurveyPostBodyFromJSONTyped(json, false);
}

export function SurveyPostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyPostBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'surveyType': !exists(json, 'survey-type') ? undefined : json['survey-type'],
        'completedAt': !exists(json, 'completed-at') ? undefined : json['completed-at'],
        'completionSpeed': !exists(json, 'completion-speed') ? undefined : json['completion-speed'],
        'completedSections': !exists(json, 'completed-sections') ? undefined : json['completed-sections'],
    };
}

export function SurveyPostBodyToJSON(value?: SurveyPostBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'survey-type': value.surveyType,
        'completed-at': value.completedAt,
        'completion-speed': value.completionSpeed,
        'completed-sections': value.completedSections,
    };
}


